<template lang="pug">
    layout.contentTransparent
        div.layoutWrapper
            v-layout(row wrap)
                v-flex(xs12)
                    div.sessionHeader

                        // Title
                        div.titleWrapper
                            h1 Practices with Subtitles


            v-data-iterator(
                item-key="id"
                content-tag="v-layout"
                no-data-text="No videos available"
                row
                wrap
                :items="sessions"
                hide-actions
            )
                template(v-slot:item="props" )
                    v-flex(xs12 sm6 md4 lg3)
                        meditation-component(:item="props.item"  :key="props.item.id" :index="props.index" :variant="variant")
</template>

<script>
    import Layout from '../../Layout/Layout';
    import Button from '~components/Button';
    import ButtonIcon from '~components/ButtonIcon';
    import Filter from '~components/Filter';
    import Separator from '~components/Separator';
    import Status from '~components/Status';
    import Title from '~components/Title';
    import VueTypes from 'vue-types';

    export default {
        components: {
            Layout,
            MeditationComponent: () => import('./Meditation'),
            TitleComponent: Title,
            ButtonComponent: Button,
            ButtonIconComponent: ButtonIcon,
            StatusComponent: Status,
            FilterComponent: Filter,
            SeparatorComponent: Separator
        },
        props: {
            variant: VueTypes.string.def('')
        },
        data() {
            return {
                sessions: [
                    {
                        id: 'd463a9e168e1cc4e26ee2a6802938a29',
                        type: 'recorded',
                        mode: 'meditation',
                        order: 1,
                        title: 'Body and Breath ',
                        description:
                            'A 10-min mindfulness practice in alternate nostril breathing followed by a meditation to notice how you feel in the body.',
                        tags: 'midday,live',
                        isLocked: false,
                        isArchived: false,
                        assignedToAll: true,
                        isSuggested: false,
                        poster_name:
                            'Screen Shot 2022-05-26 at 4-compressed (1).jpg',
                        poster:
                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com/meditation/photo/1653601533286_Screen%20Shot%202022-05-26%20at%204-compressed%20%281%29.jpg',
                        videoName: null,
                        video: null,
                        theme: 'intro',
                        duration: 608,
                        startTime: 62,
                        endTime: 582,
                        isActive: true,
                        check_in_duration: 0,
                        startedAt: '2022-05-27T03:09:00.000Z',
                        expiredAt: null,
                        createdAt: '2022-05-22T14:31:49.042Z',
                        updatedAt: '2022-07-28T18:21:07.731Z',
                        deletedAt: null,
                        instructor: {
                            id: '9f6e06ac19e62e6d701222ab6e7e71fe',
                            role: 'instructor',
                            business_id: null,
                            email: 'eileen@chillchicago.com',
                            fullName: 'Eileen A.',
                            phone: '3123420827',
                            country: null,
                            state: null,
                            city: null,
                            department: null,
                            avatar_name: 'Eileen.jpg',
                            avatar:
                                'https://s3.us-east-2.amazonaws.com/chillanywhere.com/1586208635710%20-%20Eileen.jpg',
                            rating: null,
                            comment: null,
                            position: 'Instructor',
                            information:
                                '<p>I Chill because it feels good for my body, mind, heart, and soul</p><p>My proudest moment is becoming a yoga teacher</p><p>My morning ritual is hug my husband + walk my puppy</p>',
                            stripe_customer_id: null,
                            isActive: true,
                            isEmailVerified: true,
                            commentedAt: null,
                            availableUntil: null,
                            businessType: null,
                            createdAt: '2020-04-06T21:30:24.149Z',
                            updatedAt: '2020-08-20T17:51:38.515Z',
                            subscription: null,
                            isSubscribed: null,
                            hasActiveSubscription: false,
                            subscriptionStatus: 'none',
                            permissions: 'full',
                            status: 'unregistered'
                        },
                        businesses: [
                            {
                                id: '0fffd7ca543d7a55a0050541e0573108',
                                name: 'Goldman Sachs',
                                maxUsers: 200,
                                isActive: true,
                                isChallenge: false,
                                isDefault: false,
                                type: null,
                                domain: '@gs.com',
                                createdAt: '2020-04-10T17:42:41.368Z',
                                updatedAt: '2022-08-23T18:19:48.149Z',
                                userDepartments: [],
                                definitions: {
                                    program: {
                                        id: null,
                                        startedAt: null,
                                        endedAt: null
                                    },
                                    sessions: []
                                },
                                userCount: 0
                            }
                        ],
                        todayVote: {
                            id: 'a0e1dcc96a9b5c7debcca7d7784506c8',
                            rateBefore: 25,
                            rateAfter: null,
                            isCompleted: false,
                            isSkip: false,
                            createdAt: '2022-08-28T15:22:28.031Z',
                            updatedAt: '2022-08-28T15:22:28.031Z',
                            watchedAt: null,
                            user: {
                                id: '746ed75271dc5f5b5fcec595c8ef39ae',
                                role: 'member',
                                business_id: '0fffd7ca543d7a55a0050541e0573108',
                                email: 'yevpak.i@gmail.com',
                                fullName: 'Ivan',
                                phone: '7738000000',
                                country: null,
                                state: null,
                                city: null,
                                department: null,
                                avatar_name: null,
                                avatar: null,
                                rating: null,
                                comment: null,
                                position: null,
                                information: null,
                                stripe_customer_id: '',
                                isActive: true,
                                isEmailVerified: true,
                                commentedAt: null,
                                availableUntil: '2022-12-17T18:47:43.000Z',
                                businessType: '',
                                createdAt: '2021-01-19T16:13:39.404Z',
                                updatedAt: '2022-08-26T13:49:30.426Z',
                                subscription: null,
                                isSubscribed: null,
                                hasActiveSubscription: false,
                                subscriptionStatus: 'none',
                                permissions: 'full',
                                status: 'corporate'
                            }
                        },
                        awsData: {
                            upstreamChannel: {
                                outputs: [
                                    {
                                        url:
                                            'https://cex2ftlov55tg6.data.mediastore.us-east-1.amazonaws.com/1653583921704_midday_mindfulness_a/main.m3u8'
                                    },
                                    {
                                        url:
                                            'https://cex2ftlov55tg6.data.mediastore.us-east-1.amazonaws.com/1653583921704_midday_mindfulness_b/main.m3u8'
                                    }
                                ],
                                subtitles: [
                                    {
                                        language: 'en',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/d463a9e168e1cc4e26ee2a6802938a29.srt'
                                    },
                                    {
                                        language: 'es',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/[es]d463a9e168e1cc4e26ee2a6802938a29.srt'
                                    },
                                    {
                                        language: 'ua',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/%5Bua%5Dd463a9e168e1cc4e26ee2a6802938a29.srt'
                                    }
                                ]
                            }
                        },
                        upstreamDestinations: [],
                        upstreamChannel: {
                            outputs: [
                                {
                                    url:
                                        'https://cex2ftlov55tg6.data.mediastore.us-east-1.amazonaws.com/1653583921704_midday_mindfulness_a/main.m3u8'
                                },
                                {
                                    url:
                                        'https://cex2ftlov55tg6.data.mediastore.us-east-1.amazonaws.com/1653583921704_midday_mindfulness_b/main.m3u8'
                                }
                            ]
                        }
                    },
                    {
                        id: 'b30023961fdad470ae2938d36a629dbc',
                        type: 'recorded',
                        mode: 'meditation',
                        order: 1,
                        title: 'Energetic Body',
                        description:
                            'A 15-min mindful movement practice working through grounding to uplifting movements to energize the body and mind. ',
                        tags: 'midday,live',
                        isLocked: false,
                        isArchived: false,
                        assignedToAll: true,
                        isSuggested: false,
                        poster_name:
                            'Screen Shot 2022-03-11 at 1-compressed.jpg',
                        poster:
                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com/meditation/photo/1647027437129_Screen%20Shot%202022-03-11%20at%201-compressed.jpg',
                        videoName: null,
                        video: null,
                        theme: 'yoga',
                        duration: 949,
                        startTime: 17,
                        endTime: 912,
                        isActive: true,
                        check_in_duration: 0,
                        startedAt: '2022-03-11T18:00:00.000Z',
                        expiredAt: null,
                        createdAt: '2022-03-07T01:31:40.107Z',
                        updatedAt: '2022-04-19T14:49:39.010Z',
                        deletedAt: null,
                        instructor: {
                            id: '5221a082c9ab47559ab29169d09b52b5',
                            role: 'instructor',
                            business_id: null,
                            email: 'jbfarrell13@gmail.com',
                            fullName: 'Julianne F.',
                            phone: '3123883071',
                            country: null,
                            state: null,
                            city: null,
                            department: null,
                            avatar_name: '4cac94cb3c.png',
                            avatar:
                                'https://s3.us-east-2.amazonaws.com/chillanywhere.com/1582833064083%20-%204cac94cb3c.png',
                            rating: null,
                            comment: null,
                            position: null,
                            information:
                                '<p>I Chill because it unites me with my true nature</p><p>My proudest moment is seeing my children flourish&nbsp;</p><p>My most admired character trait is kindness</p>',
                            stripe_customer_id: null,
                            isActive: true,
                            isEmailVerified: true,
                            commentedAt: null,
                            availableUntil: null,
                            businessType: null,
                            createdAt: '2020-02-27T19:23:15.134Z',
                            updatedAt: '2020-08-20T17:54:04.055Z',
                            subscription: null,
                            isSubscribed: null,
                            hasActiveSubscription: false,
                            subscriptionStatus: 'none',
                            permissions: 'full',
                            status: 'corporate'
                        },
                        awsData: {
                            upstreamChannel: {
                                outputs: [
                                    {
                                        url:
                                            'https://cex2ftlov55tg6.data.mediastore.us-east-1.amazonaws.com/1647021121300_midday_mindful_movement_a/main.m3u8'
                                    },
                                    {
                                        url:
                                            'https://cex2ftlov55tg6.data.mediastore.us-east-1.amazonaws.com/1647021121300_midday_mindful_movement_b/main.m3u8'
                                    }
                                ],
                                subtitles: [
                                    {
                                        language: 'en',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/b30023961fdad470ae2938d36a629dbc.srt'
                                    },
                                    {
                                        language: 'es',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/[es]b30023961fdad470ae2938d36a629dbc.srt'
                                    },
                                    {
                                        language: 'ua',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/%5Bua%5Db30023961fdad470ae2938d36a629dbc.srt'
                                    }
                                ]
                            }
                        },
                        upstreamDestinations: [],
                        upstreamChannel: {
                            outputs: [
                                {
                                    url:
                                        'https://cex2ftlov55tg6.data.mediastore.us-east-1.amazonaws.com/1647021121300_midday_mindful_movement_a/main.m3u8'
                                },
                                {
                                    url:
                                        'https://cex2ftlov55tg6.data.mediastore.us-east-1.amazonaws.com/1647021121300_midday_mindful_movement_b/main.m3u8'
                                }
                            ]
                        }
                    },
                    {
                        id: '2359475e720fe1edbedca999c6229564',
                        type: 'recorded',
                        mode: 'meditation',
                        order: 5,
                        title: 'Shoulder Relief ',
                        description:
                            'Enjoy a short practice to reset your shoulders and relieve tension to counteract the time spent hunched over. ',
                        tags: 'shoulder,cari,stretch',
                        isLocked: false,
                        isArchived: false,
                        assignedToAll: true,
                        isSuggested: false,
                        poster_name: 'CariShoulderCompressed.jpeg',
                        poster:
                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com/meditation/photo/1653674804402_CariShoulderCompressed.jpeg',
                        videoName: 'CariStretch7min-Shoulders.mp4',
                        video:
                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com-video/meditation/video/original/1653674687107/main.mp4',
                        theme: 'yoga',
                        duration: 429,
                        startTime: null,
                        endTime: null,
                        isActive: true,
                        check_in_duration: 0,
                        startedAt: null,
                        expiredAt: null,
                        createdAt: '2022-05-27T18:07:01.984Z',
                        updatedAt: '2022-08-11T22:01:22.362Z',
                        deletedAt: null,
                        instructor: {
                            id: 'a9f4dd00c72f42aa2df15e9a61eed34f',
                            role: 'instructor',
                            business_id: null,
                            email: 'healthyselfwithcari@gmail.com',
                            fullName: 'Cari R.',
                            phone: '7735206627',
                            country: null,
                            state: null,
                            city: null,
                            department: null,
                            avatar_name: 'CariHeadShotCompressed.jpeg',
                            avatar:
                                'https://s3.us-east-2.amazonaws.com/chillanywhere.com/1603821618930%20-%20CariHeadShotCompressed.jpeg',
                            rating: null,
                            comment: null,
                            position: 'Instructor',
                            information:
                                '<p>I Chill because my mind / body / spirit deserve it</p><p>My secret talent is ukulele serenades&nbsp;</p><p>My life philosophy is, &quot;Life is a daring adventure or nothing&quot; - Helen Keller</p>',
                            stripe_customer_id: null,
                            isActive: true,
                            isEmailVerified: true,
                            commentedAt: null,
                            availableUntil: null,
                            businessType: null,
                            createdAt: '2019-10-09T14:11:08.887Z',
                            updatedAt: '2021-08-30T17:20:19.468Z',
                            subscription: null,
                            isSubscribed: null,
                            hasActiveSubscription: false,
                            subscriptionStatus: 'none',
                            permissions: 'full',
                            status: 'corporate'
                        },
                        awsData: {
                            upstreamChannel: {
                                outputs: [
                                    {
                                        url:
                                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com-video/meditation/video/converted/20220527T180720/main.m3u8'
                                    }
                                ],
                                subtitles: [
                                    {
                                        language: 'en',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/2359475e720fe1edbedca999c6229564.srt'
                                    },
                                    {
                                        language: 'es',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/[es]2359475e720fe1edbedca999c6229564.srt'
                                    },
                                    {
                                        language: 'ua',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/%5Bua%5D2359475e720fe1edbedca999c6229564.srt'
                                    }
                                ]
                            }
                        },
                        upstreamDestinations: [],
                        upstreamChannel: {
                            outputs: [
                                {
                                    url:
                                        'https://s3.us-east-2.amazonaws.com/chillanywhere.com-video/meditation/video/converted/20220527T180720/main.m3u8'
                                }
                            ]
                        }
                    },
                    {
                        id: '9922d895877b5e68d94a4411d8fd10a1',
                        type: 'recorded',
                        mode: 'meditation',
                        order: 5,
                        title: 'CHILL 101: Focus on the Breath',
                        description:
                            'Learn why focusing on the breath is an important aspect of mindful meditation. CHILL 101 series features educational videos for learning meditation basics.',
                        tags: 'chill101,cari',
                        isLocked: false,
                        isArchived: false,
                        assignedToAll: true,
                        isSuggested: false,
                        poster_name: 'CariFocusBreathCompressed.jpeg',
                        poster:
                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com/meditation/photo/1642701076973_CariFocusBreathCompressed.jpeg',
                        videoName: 'CariWhyFocusonTheBreath.mp4',
                        video:
                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com-video/meditation/video/original/1642700955531/main.mp4',
                        theme: 'intro',
                        duration: 164,
                        startTime: null,
                        endTime: null,
                        isActive: true,
                        check_in_duration: 0,
                        startedAt: null,
                        expiredAt: null,
                        createdAt: '2022-01-20T17:53:25.125Z',
                        updatedAt: '2022-01-20T17:56:00.806Z',
                        deletedAt: null,
                        instructor: {
                            id: 'a9f4dd00c72f42aa2df15e9a61eed34f',
                            role: 'instructor',
                            business_id: null,
                            email: 'healthyselfwithcari@gmail.com',
                            fullName: 'Cari R.',
                            phone: '7735206627',
                            country: null,
                            state: null,
                            city: null,
                            department: null,
                            avatar_name: 'CariHeadShotCompressed.jpeg',
                            avatar:
                                'https://s3.us-east-2.amazonaws.com/chillanywhere.com/1603821618930%20-%20CariHeadShotCompressed.jpeg',
                            rating: null,
                            comment: null,
                            position: 'Instructor',
                            information:
                                '<p>I Chill because my mind / body / spirit deserve it</p><p>My secret talent is ukulele serenades&nbsp;</p><p>My life philosophy is, &quot;Life is a daring adventure or nothing&quot; - Helen Keller</p>',
                            stripe_customer_id: null,
                            isActive: true,
                            isEmailVerified: true,
                            commentedAt: null,
                            availableUntil: null,
                            businessType: null,
                            createdAt: '2019-10-09T14:11:08.887Z',
                            updatedAt: '2021-08-30T17:20:19.468Z',
                            subscription: null,
                            isSubscribed: null,
                            hasActiveSubscription: false,
                            subscriptionStatus: 'none',
                            permissions: 'full',
                            status: 'corporate'
                        },
                        awsData: {
                            upstreamChannel: {
                                outputs: [
                                    {
                                        url:
                                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com-video/meditation/video/converted/20220120T175341/main.m3u8'
                                    }
                                ],
                                subtitles: [
                                    {
                                        language: 'en',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/9922d895877b5e68d94a4411d8fd10a1.srt'
                                    },
                                    {
                                        language: 'es',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/[es]9922d895877b5e68d94a4411d8fd10a1.srt'
                                    },
                                    {
                                        language: 'ua',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/%5Bua%5D9922d895877b5e68d94a4411d8fd10a1.srt'
                                    }
                                ]
                            }
                        },
                        upstreamDestinations: [],
                        upstreamChannel: {
                            outputs: [
                                {
                                    url:
                                        'https://s3.us-east-2.amazonaws.com/chillanywhere.com-video/meditation/video/converted/20220120T175341/main.m3u8'
                                }
                            ]
                        }
                    },
                    {
                        id: '9123f19312744cd71a0422933acc44f7',
                        type: 'recorded',
                        mode: 'meditation',
                        order: 1,
                        title: 'Cultivate Joy Yoga',
                        description:
                            'A 30-min yoga practice as an opportunity to pause, turn your senses inward and cultivate a sense of joy as you move your body.',
                        tags: 'yoga,live',
                        isLocked: false,
                        isArchived: false,
                        assignedToAll: true,
                        isSuggested: false,
                        poster_name:
                            'Screen Shot 2022-04-18 at 2-compressed.jpg',
                        poster:
                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com/meditation/photo/1650310066630_Screen%20Shot%202022-04-18%20at%202-compressed.jpg',
                        videoName: null,
                        video: null,
                        theme: 'yoga',
                        duration: 2162,
                        startTime: 144,
                        endTime: 2030,
                        isActive: true,
                        check_in_duration: 0,
                        startedAt: '2022-04-16T14:30:00.000Z',
                        expiredAt: null,
                        createdAt: '2022-04-10T15:19:01.996Z',
                        updatedAt: '2022-06-09T20:02:13.546Z',
                        deletedAt: null,
                        instructor: {
                            id: '790e57e04277f7a7b7cc2310c1e195f0',
                            role: 'instructor',
                            business_id: null,
                            email: 'strauss.stephanie@gmail.com',
                            fullName: 'Stephanie S.',
                            phone: '8479750202',
                            country: null,
                            state: null,
                            city: null,
                            department: null,
                            avatar_name: 'Steph_Chill_Profile_Temporary_BW.jpg',
                            avatar:
                                'https://s3.us-east-2.amazonaws.com/chillanywhere.com/1586445345380%20-%20Steph_Chill_Profile_Temporary_BW.jpg',
                            rating: null,
                            comment: null,
                            position: 'Instructor',
                            information:
                                '<p>I Chill because it helps me strengthen my mindfulness + gratitude + compassion muscles</p><p>My most repeated intention is I am enough</p><p>My proudest moment is the day I got to be a part of the Chill team #dreamjob</p>',
                            stripe_customer_id: null,
                            isActive: true,
                            isEmailVerified: true,
                            commentedAt: null,
                            availableUntil: null,
                            businessType: null,
                            createdAt: '2020-04-09T15:15:10.984Z',
                            updatedAt: '2021-08-04T18:56:08.797Z',
                            subscription: null,
                            isSubscribed: null,
                            hasActiveSubscription: false,
                            subscriptionStatus: 'none',
                            permissions: 'full',
                            status: 'corporate'
                        },
                        awsData: {
                            upstreamChannel: {
                                outputs: [
                                    {
                                        url:
                                            'https://cex2ftlov55tg6.data.mediastore.us-east-1.amazonaws.com/1650118921287_yoga_a/main.m3u8'
                                    },
                                    {
                                        url:
                                            'https://cex2ftlov55tg6.data.mediastore.us-east-1.amazonaws.com/1650118921287_yoga_b/main.m3u8'
                                    }
                                ],
                                subtitles: [
                                    {
                                        language: 'en',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/9123f19312744cd71a0422933acc44f7.srt'
                                    },
                                    {
                                        language: 'es',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/[es]9123f19312744cd71a0422933acc44f7.srt'
                                    },
                                    {
                                        language: 'ua',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/%5Bua%5D9123f19312744cd71a0422933acc44f7.srt'
                                    }
                                ]
                            }
                        },
                        upstreamDestinations: [],
                        upstreamChannel: {
                            outputs: [
                                {
                                    url:
                                        'https://cex2ftlov55tg6.data.mediastore.us-east-1.amazonaws.com/1650118921287_yoga_a/main.m3u8'
                                },
                                {
                                    url:
                                        'https://cex2ftlov55tg6.data.mediastore.us-east-1.amazonaws.com/1650118921287_yoga_b/main.m3u8'
                                }
                            ]
                        }
                    },
                    {
                        id: '857e07081a39d0367cf3335b557ea3dd',
                        type: 'recorded',
                        mode: 'meditation',
                        order: 5,
                        title: 'Relieve Tech Neck',
                        description:
                            'Enjoy a short stretch practice to relieve neck tension that may arise from a busy work day. ',
                        tags: 'stretch,eileen,short',
                        isLocked: false,
                        isArchived: false,
                        assignedToAll: true,
                        isSuggested: false,
                        poster_name: 'EileenCompressed.jpeg',
                        poster:
                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com/meditation/photo/1657907738830_EileenCompressed.jpeg',
                        videoName: 'EileenTechNeck.mp4',
                        video:
                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com-video/meditation/video/original/1657907672748/main.mp4',
                        theme: 'new',
                        duration: 159,
                        startTime: null,
                        endTime: 158,
                        isActive: true,
                        check_in_duration: 0,
                        startedAt: null,
                        expiredAt: null,
                        createdAt: '2022-07-15T17:56:21.382Z',
                        updatedAt: '2022-07-22T16:53:59.350Z',
                        deletedAt: null,
                        instructor: {
                            id: '9f6e06ac19e62e6d701222ab6e7e71fe',
                            role: 'instructor',
                            business_id: null,
                            email: 'eileen@chillchicago.com',
                            fullName: 'Eileen A.',
                            phone: '3123420827',
                            country: null,
                            state: null,
                            city: null,
                            department: null,
                            avatar_name: 'Eileen.jpg',
                            avatar:
                                'https://s3.us-east-2.amazonaws.com/chillanywhere.com/1586208635710%20-%20Eileen.jpg',
                            rating: null,
                            comment: null,
                            position: 'Instructor',
                            information:
                                '<p>I Chill because it feels good for my body, mind, heart, and soul</p><p>My proudest moment is becoming a yoga teacher</p><p>My morning ritual is hug my husband + walk my puppy</p>',
                            stripe_customer_id: null,
                            isActive: true,
                            isEmailVerified: true,
                            commentedAt: null,
                            availableUntil: null,
                            businessType: null,
                            createdAt: '2020-04-06T21:30:24.149Z',
                            updatedAt: '2020-08-20T17:51:38.515Z',
                            subscription: null,
                            isSubscribed: null,
                            hasActiveSubscription: false,
                            subscriptionStatus: 'none',
                            permissions: 'full',
                            status: 'unregistered'
                        },
                        awsData: {
                            upstreamChannel: {
                                outputs: [
                                    {
                                        url:
                                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com-video/meditation/video/converted/20220715T175633/main.m3u8'
                                    }
                                ],
                                subtitles: [
                                    {
                                        language: 'en',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/857e07081a39d0367cf3335b557ea3dd.srt'
                                    },
                                    {
                                        language: 'es',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/[es]857e07081a39d0367cf3335b557ea3dd.srt'
                                    },
                                    {
                                        language: 'ua',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/%5Bua%5D857e07081a39d0367cf3335b557ea3dd.srt'
                                    }
                                ]
                            }
                        },
                        upstreamDestinations: [],
                        upstreamChannel: {
                            outputs: [
                                {
                                    url:
                                        'https://s3.us-east-2.amazonaws.com/chillanywhere.com-video/meditation/video/converted/20220715T175633/main.m3u8'
                                }
                            ]
                        }
                    },
                    {
                        id: 'cffbd615926f0e8fb8e7203237895011',
                        type: 'recorded',
                        mode: 'meditation',
                        order: 5,
                        title: 'Smiling',
                        description:
                            'A two-min meditation to explore the practice of smiling. ',
                        tags: 'meditation,recorded',
                        isLocked: false,
                        isArchived: false,
                        assignedToAll: true,
                        isSuggested: false,
                        poster_name:
                            'Screen Shot 2022-02-07 at 11-compressed (5).jpg',
                        poster:
                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com/meditation/photo/1644255352788_Screen%20Shot%202022-02-07%20at%2011-compressed%20%285%29.jpg',
                        videoName: 'DarrellSmiling.mp4',
                        video:
                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com-video/meditation/video/original/1644255165883/main.mp4',
                        theme: 'intro',
                        duration: 121,
                        startTime: null,
                        endTime: null,
                        isActive: true,
                        check_in_duration: 0,
                        startedAt: null,
                        expiredAt: null,
                        createdAt: '2022-02-07T17:35:57.865Z',
                        updatedAt: '2022-02-07T17:37:58.862Z',
                        deletedAt: null,
                        instructor: {
                            id: '8d34205efc50fbf87286a126469da057',
                            role: 'instructor',
                            business_id: null,
                            email: 'darrelljonesspirit@gmail.com',
                            fullName: 'Darrell J.',
                            phone: '7734503865',
                            country: null,
                            state: null,
                            city: null,
                            department: null,
                            avatar_name: '27a774d8d5.png',
                            avatar:
                                'https://s3.us-east-2.amazonaws.com/chillanywhere.com/1582832593142%20-%2027a774d8d5.png',
                            rating: null,
                            comment: null,
                            position: null,
                            information:
                                '<p>I Chill because it keeps me sane</p><p>My source of inspiration is people living in their purpose</p><p>My Sunday soundtrack is instrumental hip-hop and classic soul</p>',
                            stripe_customer_id: null,
                            isActive: true,
                            isEmailVerified: true,
                            commentedAt: null,
                            availableUntil: null,
                            businessType: null,
                            createdAt: '2020-02-27T19:18:46.977Z',
                            updatedAt: '2020-08-20T17:43:55.721Z',
                            subscription: null,
                            isSubscribed: null,
                            hasActiveSubscription: false,
                            subscriptionStatus: 'none',
                            permissions: 'full',
                            status: 'corporate'
                        },
                        awsData: {
                            upstreamChannel: {
                                outputs: [
                                    {
                                        url:
                                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com-video/meditation/video/converted/20220207T173615/main.m3u8'
                                    }
                                ],
                                subtitles: [
                                    {
                                        language: 'en',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/cffbd615926f0e8fb8e7203237895011.srt'
                                    },
                                    {
                                        language: 'es',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/[es]cffbd615926f0e8fb8e7203237895011.srt'
                                    },
                                    {
                                        language: 'ua',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/%5Bua%5Dcffbd615926f0e8fb8e7203237895011.srt'
                                    }
                                ]
                            }
                        },
                        upstreamDestinations: [],
                        upstreamChannel: {
                            outputs: [
                                {
                                    url:
                                        'https://s3.us-east-2.amazonaws.com/chillanywhere.com-video/meditation/video/converted/20220207T173615/main.m3u8'
                                }
                            ]
                        }
                    },
                    {
                        id: '7f7d52f2373578120d8654fe531290a2',
                        type: 'recorded',
                        mode: 'meditation',
                        order: 5,
                        title: 'Stop Technique',
                        description:
                            'Practice the stop technique to explore how it may add a calm pause to your day. ',
                        tags: 'meditation',
                        isLocked: false,
                        isArchived: false,
                        assignedToAll: true,
                        isSuggested: false,
                        poster_name: 'DarrellStopTechnique.jpeg',
                        poster:
                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com/meditation/photo/1642185711964_DarrellStopTechnique.jpeg',
                        videoName: 'DarrellSMSStopTechnique.mp4',
                        video:
                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com-video/meditation/video/original/1642185577485/main.mp4',
                        theme: 'intro',
                        duration: 74,
                        startTime: null,
                        endTime: null,
                        isActive: true,
                        check_in_duration: 0,
                        startedAt: null,
                        expiredAt: null,
                        createdAt: '2022-01-14T18:42:43.282Z',
                        updatedAt: '2022-02-14T19:11:26.027Z',
                        deletedAt: null,
                        instructor: {
                            id: '8d34205efc50fbf87286a126469da057',
                            role: 'instructor',
                            business_id: null,
                            email: 'darrelljonesspirit@gmail.com',
                            fullName: 'Darrell J.',
                            phone: '7734503865',
                            country: null,
                            state: null,
                            city: null,
                            department: null,
                            avatar_name: '27a774d8d5.png',
                            avatar:
                                'https://s3.us-east-2.amazonaws.com/chillanywhere.com/1582832593142%20-%2027a774d8d5.png',
                            rating: null,
                            comment: null,
                            position: null,
                            information:
                                '<p>I Chill because it keeps me sane</p><p>My source of inspiration is people living in their purpose</p><p>My Sunday soundtrack is instrumental hip-hop and classic soul</p>',
                            stripe_customer_id: null,
                            isActive: true,
                            isEmailVerified: true,
                            commentedAt: null,
                            availableUntil: null,
                            businessType: null,
                            createdAt: '2020-02-27T19:18:46.977Z',
                            updatedAt: '2020-08-20T17:43:55.721Z',
                            subscription: null,
                            isSubscribed: null,
                            hasActiveSubscription: false,
                            subscriptionStatus: 'none',
                            permissions: 'full',
                            status: 'corporate'
                        },
                        awsData: {
                            upstreamChannel: {
                                outputs: [
                                    {
                                        url:
                                            'https://s3.us-east-2.amazonaws.com/chillanywhere.com-video/meditation/video/converted/20220114T184301/main.m3u8'
                                    }
                                ],
                                subtitles: [
                                    {
                                        language: 'en',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/7f7d52f2373578120d8654fe531290a2.srt'
                                    },
                                    {
                                        language: 'es',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/[es]7f7d52f2373578120d8654fe531290a2.srt'
                                    },
                                    {
                                        language: 'ua',
                                        location:
                                            'https://chill-dev.s3.us-east-2.amazonaws.com/subs/%5Bua%5D7f7d52f2373578120d8654fe531290a2.srt'
                                    }
                                ]
                            }
                        },
                        upstreamDestinations: [],
                        upstreamChannel: {
                            outputs: [
                                {
                                    url:
                                        'https://s3.us-east-2.amazonaws.com/chillanywhere.com-video/meditation/video/converted/20220114T184301/main.m3u8'
                                }
                            ]
                        }
                    }
                ]
            };
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'
    @import "../../../../assets/style/_mixins.styl"

    .createButtonWrapper
        display: flex
        justify-content: flex-end

    >>> .contentInner
        align-items: center
        justify-content: center
        display: flex

    .layoutWrapper
        max-width: 1150px

    .text-left
        text-align: left

    .instructorName
        padding-bottom: 10px
        font-size: 12px

    .description
        position: relative

        &:before
            position: absolute
            top: 8px
            left: 105px
            content: ""
            width: 75%
            height: 1px
            background: linear-gradient(90deg, rgba(255, 255, 255, 0.35) 70%, #022341 100%)

        &:after
            position: absolute
            top: 8px
            left: 0
            content: ""
            width: 20px
            height: 1px
            background: $theme.secondary

    .title
        margin-left: 20px
        padding: 5px 10px
        background-color: $theme.primary
        font-size: 12px !important
        color: $theme.secondary

    >>> .dateHeader
        min-width: 180px
        max-width: 200px

    >>> .SessionActions
        min-width: 210px

    >>> .date-filter-input
        .v-label
        .v-label.v-label--active
            color: $theme.white

        .v-input__icon .v-icon
            color: $theme.white

        &.v-text-field > .v-input__control > .v-input__slot:after
            border-style: none

    .MeditationName
        display: flex
        padding-top: 10px

    .linkAction
        color: $theme.primary
        font-size: 14px

    .filters
        display: flex
        align-items: center
        margin-bottom: 30px

    .sessionHeader
        display: flex
        align-items: center
        justify-content: space-between
        flex-direction: row
        margin: 18px 0 30px
        position: relative

        &.withLogo
            margin: 8px 0 24px

        .titleWrapper h1
            padding-bottom: 0
            margin-bottom: 0
            font-size: remify(40px)
            color: $theme.white
            font-weight: 300

    .businessImageWrapper
        display: flex

    .preloader
        position: absolute
        right: 0
        top: -16px

    .businessImage
        border-radius: 10px
        overflow: hidden

        img
            width: 65px
            height: 65px

    .clearAllFilters
        opacity: 0.7
        border-radius: 5px

        span
            font-size: 14px

        i
            font-size: 16px

        span
            text-transform: capitalize

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .sessionHeader
            margin: 24px 0 16px

            .titleWrapper h1
                font-size: remify(20px)
                margin-bottom: 0

        .filters
            flex-wrap: nowrap
            margin-bottom: 12px
            align-items: center

            > div
                width: auto
                margin-bottom: 0
                margin-right: 12px !important

        .clearAllFilters
            span
                font-size: 12px
        .createButtonWrapper
            flex-direction: column

            .btn
                margin-bottom: 10px !important
                width: 100%
</style>
